import { PAYMENT_API_PATHS, type StartRazorpayCheckoutInput, type VerifyRazorpayInput } from '../constants/payments'
import { apiRequest } from './client'
import type { ApiCheckout } from './types'

export function startRazorpayCheckout(input: StartRazorpayCheckoutInput): Promise<unknown> {
  return apiRequest<unknown>(PAYMENT_API_PATHS.razorpayCheckout, {
    method: 'POST',
    auth: true,
    body: input,
  })
}

export function verifyRazorpayPayment(input: VerifyRazorpayInput): Promise<ApiCheckout> {
  return apiRequest<ApiCheckout>(PAYMENT_API_PATHS.razorpayVerify, {
    method: 'POST',
    auth: true,
    body: input,
  })
}
